import { put, select } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { sagaActions } from '../sagas'
import _requestActivateUser from 'store/sagas/requestActivateUser'
import {
  remove as removeUser
} from '../redux/users'

export default function * requestActivateUser (action) {
  const { id } = action.payload

  const state = yield select()

  const currentUser = state['view-home'].users.usersById[id]

  let optimisticAction
  if (currentUser) {
    optimisticAction = yield optimisticPut(removeUser({
      id
    }))
  }

  try {
    yield _requestActivateUser({
      payload: {
        id
      }
    })

    if (currentUser) {
      yield optimisticAction.commit()
    }

    if (id === state.kanbo.currentUser.id) {
      yield put(sagaActions.fetchPermissionLevel())
    }
  } catch (error) {
    if (currentUser) {
      yield optimisticAction.revert()
    }

    throw error
  }
}
